import { forwardRef } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import './primitives.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, ...rest },
  ref,
) {
  const classes = ['lm-checkbox', className].filter(Boolean).join(' ');
  return (
    <label className={classes}>
      <input ref={ref} type="checkbox" {...rest} />
      <span className="lm-checkbox__box">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
          <path
            d="M1.5 5l2.5 2.5L8.5 2.5"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      {label && <span>{label}</span>}
    </label>
  );
});
